import { Button, Callout, Card } from '@apovisio/ui';
import type { GuestState } from '@apovisio/contracts';
import { BrandMark } from '../../app/BrandMark';
import { PageHeading } from '../../components/PageHeading';
import type { StreamStatus } from '../../lib/event-stream';

/**
 * Écran 7 — Salle d'attente : état explicite, aucun faux chargement. Le texte reflète
 * exactement l'état reçu du serveur.
 */
export function WaitingView({
  state,
  stream,
  onCancel,
  onRetry,
  cancelling,
}: {
  state: GuestState;
  stream: StreamStatus;
  onCancel: () => void;
  onRetry: () => void;
  cancelling: boolean;
}) {
  const initials = (state.displayName ?? '?')
    .split(/\s+/)
    .map((part) => part.charAt(0))
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return (
    <main className="app-centered">
      <Card padding="lg" className="app-narrow" as="div">
        <BrandMark />
        <div className="app-waiting__avatar" aria-hidden="true">
          {initials}
        </div>
        <div className="av-stack av-stack--sm">
          <PageHeading documentTitle="Demande envoyée">Demande envoyée</PageHeading>
          <p className="av-text-secondary">
            {state.meeting.title} · vous apparaîtrez comme « {state.displayName} »
          </p>
        </div>
        <div role="status" className="av-stack av-stack--sm">
          {stream === 'reconnecting' ? (
            <Callout tone="warning" title="Connexion perdue. Reconnexion en cours…">
              Votre demande reste valable pendant la reconnexion.
            </Callout>
          ) : stream === 'failed' ? (
            <Callout tone="danger" title="Impossible de se reconnecter.">
              <Button variant="secondary" onClick={onRetry}>
                Réessayer
              </Button>
            </Callout>
          ) : state.hostPresent ? (
            <p>L’organisateur va valider votre entrée. Gardez cette page ouverte.</p>
          ) : (
            <Callout tone="info" title="L’organisateur n’est pas encore connecté.">
              Votre demande lui sera présentée dès son arrivée.
            </Callout>
          )}
        </div>
        <Button variant="secondary" loading={cancelling} onClick={onCancel}>
          Annuler ma demande
        </Button>
      </Card>
    </main>
  );
}
